import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { RegistrationStep } from './models/registration-step.model';
import { WizardType } from '../models/wizard-type';
import { LoggingService } from '../../shared/services/core/logging.service';

export interface RegistrationStepState extends EntityState<RegistrationStep> {
  wizardType?: WizardType;
  isComplete: boolean;
  queryData?: { [key: string]: any };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'registration-step', idKey: 'Step' })
export class RegistrationStepStore extends EntityStore<RegistrationStepState> {
  constructor(private logService: LoggingService) {
    super();
  }

  /** Update the current wizard type in the state. */
  updateWizardType(value: WizardType) {
    this.logService.debug('Updating current wizard type', value);
    this.update({ wizardType: value });
  }

  /** Update whether all steps have been complete in the state. */
  updateIsComplete(value: boolean) {
    this.logService.debug('Updating registration completion status', value);
    this.update({ isComplete: value });
  }

  /** Update the query data in the state. */
  updateQueryData(value: { [key: string]: any }) {
    this.logService.debug('Updating registration query data', value);
    this.update({ queryData: value });
  }

  selectWizardType() {
    return this._select(state => state.wizardType);
  }
}
